import { getUserId } from 'lib/utils/authentication';
import RelayEnvironment from 'lib/utils/relay';
import { loadQuery } from 'react-relay';
import { USER_PROFILE_QUERY } from 'services/user/user.relay.services';
import { userProfileQuery } from 'services/user/__generated__/userProfileQuery.graphql';

export const SettingsClientPreferencesPreloadData = Props => {
  const userId = getUserId();

  return {
    userId,
    userProfileRef: loadQuery<userProfileQuery>(
      RelayEnvironment,
      USER_PROFILE_QUERY,
      {
        id: userId,
        skip: userId === '',
      },
      { fetchPolicy: 'network-only' },
    ),
  };
};

export type SettingsClientPreferencesPreloadDataType = ReturnType<typeof SettingsClientPreferencesPreloadData>;
